const searchBoxes = document.querySelectorAll(".search-bar");

for (const searchBox of searchBoxes) {
  searchBox.addEventListener("submit", function (e) {
    e.preventDefault();
    const input = e.target.querySelector('input[type="search"]');
    const search = input?.value || "";

    if (!input || !search) {
      return;
    }

    input.value = "";

    const a = document.createElement("a");
    a.href = `https://app.e-ilustrace.cz/search?searchWithCategory=${search}~ALL~V%C5%A1e~FTXF`;
    a.click();
  });
}
